// extracted by css-extract-rspack-plugin
module.exports =  {"card":"AddGroupCard-m_jy__card","icon":"AddGroupCard-Y88s__icon","label":"AddGroupCard-vRKq__label"};